const actionScope = '[Menu Settings]';

export class LoadMenuSettings {
  static readonly type = `${actionScope} Load Menu Settings`;
}

export class LoadMenuSettingsIfNotLoaded {
  static readonly type = `${actionScope} Load Menu Settings If Not Loaded`;
}

export class UpdateMenuSettings {
  static readonly type = `${actionScope} Update Menu Settings`;

  constructor(public isMenuCollapsed: boolean) {}
}
